import { RailSafetyOfficer } from "../models/rail-safety-officer";

export class GetRailSafetyOfficers {
    static railSafetyOfficers: RailSafetyOfficer[] = [
        {
            "id": 153148,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "derek.heneker@onrsr.com.au",
            "fullName": "Derek Heneker",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 999001,
            "jobTitle": "Rail Safety Officer",
            "Email": "demo.user@onrsr.com.au",
            "fullName": "Demo User",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153149,
            "jobTitle": "Principal Rail Safety Officer",
            "Email": "peter.clements@onrsr.com.au",
            "fullName": "Peter Clements",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153152,
            "jobTitle": "General Manager",
            "Email": "ewald.eisele@onrsr.com.au",
            "fullName": "Ewald Eisele",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153158,
            "jobTitle": "Principal Rail Safety Officer",
            "Email": "gerrard.joseph@onrsr.com.au",
            "fullName": "Gerrard Joseph",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153159,
            "jobTitle": "Manager Operations",
            "Email": "grant.windsham@onrsr.com.au",
            "fullName": "Grant Windsham",
            "AssignedOffice": "Sydney"
        },
        {
            "id": 153163,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "robert.venticinque@onrsr.com.au",
            "fullName": "Robert Venticinque",
            "AssignedOffice": "Sydney"
        },
        {
            "id": 153166,
            "jobTitle": "Principal Rail Safety Officer",
            "Email": "craig.wright@onrsr.com.au",
            "fullName": "Craig Wright",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153167,
            "jobTitle": "Rail Safety Officer",
            "Email": "terry.doffay@onrsr.com.au",
            "fullName": "Terry Doffay",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153168,
            "jobTitle": "Rail Safety Officer",
            "Email": "rod.pilmore@onrsr.com.au",
            "fullName": "Rod Pilmore",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153169,
            "jobTitle": "Rail Safety Officer",
            "Email": "darrel.jansz@onrsr.com.au",
            "fullName": "Darrel Jansz",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153171,
            "jobTitle": "General Manager",
            "Email": "nadine.gewargis@onrsr.com.au",
            "fullName": "Nadine Gewargis",
            "AssignedOffice": "Sydney"
        },
        {
            "id": 153177,
            "jobTitle": "Principal Rail Safety Officer",
            "Email": "paul.butler@onrsr.com.au",
            "fullName": "Paul Butler",
            "AssignedOffice": "Perth"
        },
        {
            "id": 153183,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "adele.matthews@onrsr.com.au",
            "fullName": "Adele Matthews",
            "AssignedOffice": "Perth"
        },
        {
            "id": 153186,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "michael.barton@onrsr.com.au",
            "fullName": "Michael Barton",
            "AssignedOffice": "Perth"
        },
        {
            "id": 153187,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "andrew.gee@onrsr.com.au",
            "fullName": "Andrew Gee",
            "AssignedOffice": "Perth"
        },
        {
            "id": 153190,
            "jobTitle": "General Manager",
            "Email": "ty.graham@onrsr.com.au",
            "fullName": "Ty Graham",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153193,
            "jobTitle": "General Manager",
            "Email": "greg.wagner@onrsr.com.au",
            "fullName": "Greg Wagner",
            "AssignedOffice": "Brisbane"
        },
        {
            "id": 153195,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "cameron.crothers@onrsr.com.au",
            "fullName": "Cameron Crothers",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153197,
            "jobTitle": "Principal Rail Safety Officer",
            "Email": "ross.lussick@onrsr.com.au",
            "fullName": "Ross Lussick",
            "AssignedOffice": "Brisbane"
        },
        {
            "id": 153198,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "nick.sladden@onrsr.com.au",
            "fullName": "Nick Sladden",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153201,
            "jobTitle": "Principal Rail Safety Officer",
            "Email": "mitchell.partridge@onrsr.com.au",
            "fullName": "Mitchell Partridge",
            "AssignedOffice": "Sydney"
        },
        {
            "id": 153202,
            "jobTitle": "Rail Safety Officer",
            "Email": "marijana.stipic@onrsr.com.au",
            "fullName": "Marijana Stipic",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153204,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "daniel.wright@onrsr.com.au",
            "fullName": "Daniel Wright",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153206,
            "jobTitle": "Rail Safety Officer",
            "Email": "gerry.giuliani@onrsr.com.au",
            "fullName": "Gerry Giuliani",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153216,
            "jobTitle": "Manager Operations",
            "Email": "peter.martin@onrsr.com.au",
            "fullName": "Peter Martin",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153219,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "shaun.crowe@onrsr.com.au",
            "fullName": "Shaun Crowe",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153221,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "nikki.smart@onrsr.com.au",
            "fullName": "Nikki Smart",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153225,
            "jobTitle": "Manager Operations",
            "Email": "mark.dyson@onrsr.com.au",
            "fullName": "Mark Dyson",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153228,
            "jobTitle": "Principal Rail Safety Officer",
            "Email": "brett.mcwatters@onrsr.com.au",
            "fullName": "Brett McWatters",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153229,
            "jobTitle": "Senior Rail Safety Office",
            "Email": "malcolm.boag@onrsr.com.au",
            "fullName": "Malcolm Boag",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153240,
            "jobTitle": "Rail Safety Officer",
            "Email": "lucy.arthur@onrsr.com.au",
            "fullName": "Lucy Arthur",
            "AssignedOffice": "Sydney"
        },
        {
            "id": 153242,
            "jobTitle": "Rail Safety Officer",
            "Email": "tracy.muller@onrsr.com.au",
            "fullName": "Tracy Muller",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153251,
            "jobTitle": "Rail Safety Officer",
            "Email": "james.jasper@onrsr.com.au",
            "fullName": "James Jasper",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153252,
            "jobTitle": "Rail Safety Officer",
            "Email": "brent.henriksen@onrsr.com.au",
            "fullName": "Brent Henriksen",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153253,
            "jobTitle": "Rail Safety Officer",
            "Email": "anthea.mctigue@onrsr.com.au",
            "fullName": "Anthea McTigue",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153254,
            "jobTitle": "Rail Safety Officer",
            "Email": "violet.ball@onrsr.com.au",
            "fullName": "Violet Ball",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153255,
            "jobTitle": "Rail Safety Officer",
            "Email": "bianca.tuckwell@onrsr.com.au",
            "fullName": "Bianca Tuckwell",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153256,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "cameron.weston@onrsr.com.au",
            "fullName": "Cameron Weston",
            "AssignedOffice": "Sydney"
        },
        {
            "id": 153257,
            "jobTitle": "Rail Safety Officer",
            "Email": "jennifer.edmonds@onrsr.com.au",
            "fullName": "Jennifer Edmonds",
            "AssignedOffice": "Sydney"
        },
        {
            "id": 153258,
            "jobTitle": "Rail Safety Officer",
            "Email": "chloe.marquesbelloff@onrsr.com.au",
            "fullName": "Chloe Marques Belloff",
            "AssignedOffice": "Sydney"
        },
        {
            "id": 153259,
            "jobTitle": "Rail Safety Officer",
            "Email": "mason.garlick@onrsr.com.au",
            "fullName": "Mason Garlick",
            "AssignedOffice": "Sydney"
        },
        {
            "id": 153260,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "ophelia.lockyer@onrsr.com.au",
            "fullName": "Ophelia Lockyer",
            "AssignedOffice": "Sydney"
        },
        {
            "id": 153261,
            "jobTitle": "Rail Safety Officer",
            "Email": "shanell.teu@onrsr.com.au",
            "fullName": "Shanell Teua",
            "AssignedOffice": "Sydney"
        },
        {
            "id": 153263,
            "jobTitle": "Rail Safety Officer",
            "Email": "narelle.irwin@onrsr.com.au",
            "fullName": "Narelle Irwin",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153264,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "isaac.patterson@onrsr.com.au",
            "fullName": "Isaac Patterson",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153265,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "joe.lovett@onrsr.com.au",
            "fullName": "Joe Lovett",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153266,
            "jobTitle": "General Manager",
            "Email": "david.rankine@onrsr.com.au",
            "fullName": "David Rankine",
            "AssignedOffice": "Perth"
        },
        {
            "id": 153267,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "dann.westlake@onrsr.com.au",
            "fullName": "Dann Westlake",
            "AssignedOffice": "Perth"
        },
        {
            "id": 153268,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "kunaal.karan@onrsr.com.au",
            "fullName": "Kunaal Karan",
            "AssignedOffice": "Perth"
        },
        {
            "id": 153269,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "emily.williams@onrsr.com.au",
            "fullName": "Emily Williams",
            "AssignedOffice": "Perth"
        },
        {
            "id": 153270,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "paul.kelly@onrsr.com.au",
            "fullName": "Paul Kelly",
            "AssignedOffice": "Perth"
        },
        {
            "id": 153271,
            "jobTitle": "Manager Operations",
            "Email": "christa.gibson@onrsr.com.au",
            "fullName": "Christa Gibson",
            "AssignedOffice": "Brisbane"
        },
        {
            "id": 153272,
            "jobTitle": "Principal Rail Safety Officer",
            "Email": "paulson.paul@onrsr.com.au",
            "fullName": "Paulson Paul",
            "AssignedOffice": "Brisbane"
        },
        {
            "id": 153273,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "alli.browne@onrsr.com.au",
            "fullName": "Alli Browne",
            "AssignedOffice": "Brisbane"
        },
        {
            "id": 153274,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "christian.lecordier@onrsr.com.au",
            "fullName": "Christian Le Cordier",
            "AssignedOffice": "Brisbane"
        },
        {
            "id": 153275,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "matthew.obrien@onrsr.com.au",
            "fullName": "Matthew O'Brien",
            "AssignedOffice": "Brisbane"
        },
        {
            "id": 153276,
            "jobTitle": "Rail Safety Officer",
            "Email": "andrew.scurr@onrsr.com.au",
            "fullName": "Andrew Scurr",
            "AssignedOffice": "Brisbane"
        },
        {
            "id": 153277,
            "jobTitle": "Senior Rail Safety Officer",
            "Email": "kate.clark@onrsr.com.au",
            "fullName": "Kate Clark",
            "AssignedOffice": "Brisbane"
        },
        {
            "id": 153278,
            "jobTitle": "Rail Safety Officer",
            "Email": "scott.baumgart@onrsr.com.au",
            "fullName": "Scott Baumgart",
            "AssignedOffice": "Brisbane"
        },
        {
            "id": 153279,
            "jobTitle": "Rail Safety Officer",
            "Email": "david.pridgeon@onrsr.com.au",
            "fullName": "David Pridgeon",
            "AssignedOffice": "Adelaide"
        },
        {
            "id": 153280,
            "jobTitle": "Rail Safety Officer",
            "Email": "jason.yuan@onrsr.com.au",
            "fullName": "Jason Yuan",
            "AssignedOffice": "Melbourne"
        },
        {
            "id": 153281,
            "jobTitle": "Rail Safety Officer",
            "Email": "nathan.cronin-earl@onrsr.com.au",
            "fullName": "Nathan Cronin-Earl",
            "AssignedOffice": "Melbourne"
        }
    ]
}
